var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.17539 5.23338V4.58576C2.17539 2.43319 3.88146 0.700043 6.00039 0.700043C8.11932 0.700043 9.82539 2.43319 9.82539 4.58576V5.23338M2.17539 5.23338C1.47414 5.23338 0.900391 5.81623 0.900391 6.52861V13.0048C0.900391 13.7172 1.47414 14.3 2.17539 14.3H9.82539C10.5266 14.3 11.1004 13.7172 11.1004 13.0048V6.52861C11.1004 5.81623 10.5266 5.23338 9.82539 5.23338M2.17539 5.23338H9.82539M6.00039 8.47147C6.70164 8.47147 7.27539 9.05433 7.27539 9.76671C7.27539 10.4791 6.70164 11.0619 6.00039 11.0619C5.29914 11.0619 4.72539 10.4791 4.72539 9.76671C4.72539 9.05433 5.29914 8.47147 6.00039 8.47147Z",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockBlack);
export default __webpack_public_path__ + "static/media/lock_black.01b08c6f8a98d123a8d1b26dcf9f1150.svg";
export { ForwardRef as ReactComponent };